import { serverHttp as Request } from './http'
class UserService {
  // 用户登录
  login(params) {
    return Request.post('sharkfoto/login', params)
  }
  // 用户注册
  register(params) {
    return Request.post('sharkfoto/register',params)
  }
  // 注册校验
  registerVerify(params) {
    return Request.post('sharkfoto/register/verify', params)
  }
  // 获取用户信息
  getInfo(params) {
    return Request.get('sharkfoto/get_user_info', { params })
  }
  // 获取用户订单
  getOrders(params) {
    return Request.get('sharkfoto/get_order_info', { params })
  }
  // 退出登录
  logout(params) {
    return Request.get('sharkfoto/logout', { params })
  }
  // 修改用户信息
  updateInfo(userId, params) {
    return Request.post(`sharkfoto/get_user_info?user_id=${userId}`, params)
  }
  // 获取邮箱验证码
  getEmailCode(params) {
    return Request.post('sharkfoto/send_email', params)
  }

  getUserIp() {
    return Request.get('sharkfoto/get_ip')
  }
  // ----------------------第三方登录-----------------
  // 谷歌登录
  loginWithGoogle(params) {
    return Request.post('sharkfoto/third_part_login/login_with_google', params)
  }
  loginWithApple(params) {
    return Request.post('sharkfoto/third_part_login/login_with_apple', params)
  }
  // ----------------------第三方登录-----------------
}

export default new UserService()